export function generateMockCalendarData(): any[][] {
  const mockData: any[][] = [];
  const today = new Date();
  
  const events = [
    ['2024-08-20', 'Team Meeting', 'John Doe', 'In Progress'],
    ['2024-08-21', 'Project Review', 'Jane Smith', 'Scheduled'],
    ['2024-08-22', 'Client Call', 'Bob Johnson', 'Confirmed'],
    ['2024-08-23', 'Sprint Planning', 'Alice Brown', 'Pending'],
    ['2024-08-24', 'Code Review', 'Charlie Wilson', 'Completed'],
    ['2024-08-25', 'Demo Preparation', 'Diana Davis', 'In Progress'],
    ['2024-08-26', 'Release Planning', 'Eve Miller', 'Scheduled'],
    ['2024-08-27', 'User Testing', 'Frank Garcia', 'Pending'],
    ['2024-08-28', 'Bug Triage', 'Grace Lee', 'In Progress'],
    ['2024-08-29', 'Performance Review', 'Henry Kim', 'Scheduled'],
    ['2024-08-30', 'Architecture Meeting', 'Ivy Chen', 'Confirmed'],
    ['2024-09-02', 'Quarterly Planning', 'Jack Thompson', 'Pending'],
    ['2024-09-03', 'Security Audit', 'Kate Rodriguez', 'Scheduled'],
    ['2024-09-04', 'Training Session', 'Liam O\'Connor', 'Confirmed'],
    ['2024-09-05', 'Product Demo', 'Maya Patel', 'In Progress']
  ];
  
  mockData.push(['Date', 'Event', 'Assignee', 'Status']);
  
  events.forEach(event => mockData.push(event));
  
  for (let i = mockData.length; i < 25; i++) {
    mockData.push(['', '', '', '']);
  }
  
  return mockData;
}

export function generateMockChartData(): any[][] {
  const mockData: any[][] = [];
  
  const chartData = [
    ['Month', 'Revenue', 'Expenses', 'Profit', 'Users'],
    ['Jan', 45000, 32000, 13000, 1250],
    ['Feb', 52000, 35000, 17000, 1380],
    ['Mar', 48000, 33000, 15000, 1420],
    ['Apr', 61000, 38000, 23000, 1650],
    ['May', 55000, 36000, 19000, 1580],
    ['Jun', 67000, 41000, 26000, 1750],
    ['Jul', 59000, 37000, 22000, 1680],
    ['Aug', 63000, 39000, 24000, 1820],
    ['Sep', 58000, 35000, 23000, 1720],
    ['Oct', 71000, 42000, 29000, 1950],
    ['Nov', 68000, 40000, 28000, 1880],
    ['Dec', 75000, 45000, 30000, 2100]
  ];
  
  chartData.forEach(row => mockData.push(row));
  
  for (let i = mockData.length; i < 25; i++) {
    mockData.push(['', '', '', '', '']);
  }
  
  return mockData;
}

export function generateMockGridData(): any[][] {
  const mockData: any[][] = [];
  
  const gridData = [
    ['Task ID', 'Title', 'Assignee', 'Status', 'Priority', 'Due Date', 'Progress'],
    ['TSK-001', 'Implement user authentication', 'John Doe', 'In Progress', 'High', '2024-08-25', '75%'],
    ['TSK-002', 'Design dashboard mockups', 'Jane Smith', 'Completed', 'Medium', '2024-08-20', '100%'],
    ['TSK-003', 'Set up CI/CD pipeline', 'Bob Johnson', 'Pending', 'High', '2024-08-30', '0%'],
    ['TSK-004', 'Write API documentation', 'Alice Brown', 'In Progress', 'Medium', '2024-08-28', '45%'],
    ['TSK-005', 'Conduct user testing', 'Charlie Wilson', 'Scheduled', 'Low', '2024-09-05', '0%'],
    ['TSK-006', 'Optimize database queries', 'Diana Davis', 'In Progress', 'High', '2024-08-26', '60%'],
    ['TSK-007', 'Create mobile responsive design', 'Eve Miller', 'Pending', 'Medium', '2024-09-02', '0%'],
    ['TSK-008', 'Implement error handling', 'Frank Garcia', 'In Progress', 'High', '2024-08-29', '30%'],
    ['TSK-009', 'Security vulnerability assessment', 'Grace Lee', 'Completed', 'High', '2024-08-22', '100%'],
    ['TSK-010', 'Performance optimization', 'Henry Kim', 'In Progress', 'Medium', '2024-09-01', '20%']
  ];
  
  gridData.forEach(row => mockData.push(row));
  
  for (let i = mockData.length; i < 25; i++) {
    mockData.push(['', '', '', '', '', '', '']);
  }
  
  return mockData;
}

export function checkDemoMode(): boolean {
  return import.meta.env.MODE === 'development' || 
         localStorage.getItem('demo_mode') === 'true' ||
         window.location.search.includes('demo=true');
}

export function generateMockKanbanData(): any[][] {
  const mockData: any[][] = [];
  
  const kanbanData = [
    ['ID', 'Title', 'Status', 'Assignee', 'Priority', 'Labels'],
    ['KB-001', 'User Registration Flow', 'Backlog', 'John Doe', 'High', 'frontend,auth'],
    ['KB-002', 'Payment Integration', 'In Progress', 'Jane Smith', 'Critical', 'backend,payment'],
    ['KB-003', 'Mobile App Testing', 'Review', 'Bob Johnson', 'Medium', 'mobile,testing'],
    ['KB-004', 'Database Migration', 'Done', 'Alice Brown', 'High', 'backend,database'],
    ['KB-005', 'UI Component Library', 'In Progress', 'Charlie Wilson', 'Medium', 'frontend,ui'],
    ['KB-006', 'API Rate Limiting', 'Backlog', 'Diana Davis', 'Low', 'backend,security'],
    ['KB-007', 'Email Notifications', 'Review', 'Eve Miller', 'Medium', 'backend,notifications'],
    ['KB-008', 'Search Functionality', 'In Progress', 'Frank Garcia', 'High', 'frontend,search'],
    ['KB-009', 'Data Analytics Dashboard', 'Backlog', 'Grace Lee', 'Medium', 'analytics,dashboard'],
    ['KB-010', 'User Profile Management', 'Done', 'Henry Kim', 'Medium', 'frontend,profile']
  ];
  
  kanbanData.forEach(row => mockData.push(row));
  
  for (let i = mockData.length; i < 25; i++) {
    mockData.push(['', '', '', '', '', '']);
  }
  
  return mockData;
}
